module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAALBJREFUSIljYBjqgJGBgYFh8eq9DYwMjPbUNPg/w/+DsaHODSwQWxjtGRj+O1DTAkaI2xmYqGkoNjBqwSC2QE9LkUFPS5EsMWTAgktCTFSAbDGiLHj1+gPZYkRZcOnafbLFkMEwTkWjFsAACwMDpOyGFa8IgKv4ZjxAjMH/Gf4fZGBgwDCVgYGBgWHx6t0OjAxM+1E1MDTGhjo3EGM4MsCZDyg1mCBYvHq3A9UNHZIAABOYLtwT0CdaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImg/3.png
// module id = 3km0
// module chunks = 171